<template>
  <div style="z-index:7">
    <v-progress-linear
      v-show="loading"
      data-test="progress"
      indeterminate
      absolute
      class="loader"
      color="primary darken-2 "
    />
    <v-overlay
      data-test="overlay"
      :value="overlayInLoading"
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'Loader',
    computed: {
      ...mapGetters({
        loading: 'core/loading',
        overlayInLoading: 'core/overlayInLoading',
      }),
    },
  }
</script>
<style scoped lang="scss">
 .loader {
   z-index: 6;
 }
</style>
